module.exports = __webpack_public_path__ + "img/pc.3fd4acef.png";